import { lazy, Suspense, useCallback, useRef } from 'react';
import { useModal } from '@farmshare/ui-components';

import { ALL_SHOWN_STATUSES } from 'pages/processor/lib/helpers/processorStatusPresentation';

const GlobalSearchModal = lazy(() =>
  import('./global-search-modal').then((m) => ({
    default: m.GlobalSearchModal,
  })),
);

export function useGlobalSearch() {
  const { info } = useModal();
  const openCountRef = useRef(0);

  const openGlobalSearch = useCallback(() => {
    openCountRef.current += 1;
    const instanceKey = openCountRef.current;
    info({
      type: 'info',
      title: 'Search Jobs & Customers',
      size: 'sm',
      footer: null,
      hideHeader: true,
      dialogProps: {
        sx: {
          '& .MuiDialogContent-root': {
            borderTop: 'none',
            borderBottom: 'none',
          },
          '& .MuiDialogActions-root': {
            display: 'none',
          },
        },
      },
      body: (modalProps) => (
        <Suspense fallback={null}>
          <GlobalSearchModal
            key={instanceKey}
            onClose={() => modalProps.onClose?.()}
            allStatuses={ALL_SHOWN_STATUSES}
          />
        </Suspense>
      ),
    });
  }, [info]);

  return { openGlobalSearch };
}
